import React, { useEffect, useState } from 'react';
import Grid2 from "@mui/material/Grid2";
import { useForm } from 'react-hook-form';
import { UpdateResponsables, useResponsables } from '../../hooks/useResponsables';
import InputSelectSearch from '../../../../components/inputs/yup/materialui/inputSelectSearch';
import { Responsables } from '../../hooks/useResponsables'
import { Card, CardContent, Typography } from '@mui/material';
import MButton from '../../../../components/inputs/yup/materialui/mButton';
import EditIcon from '@mui/icons-material/Edit';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import CloseIcon from '@mui/icons-material/Close';
import { actualizarResponsables, copiarResponsables } from '../../services/serviceResponsables';
import { useToast } from '../../../../hooks/useToast';
import { StatusCode, TipoFuncionalidad } from '../../../../utils/enums';
import * as Yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import ConfirmationModal from '../../../../components/ui/materialui/confirmationModal';
import { PermissionGuard } from '../../../../components/auth/ProtectedRoute';
import { useUserRolesContext } from '../../../../context/userRolesContext';
import { DetalleMutuoPermissionGuard } from '../../../../components/auth/DetalleMutuoPermissionGuard';

interface IProps {
    idMutuo: number;
    isComplementario: boolean;
    esMutuoNormalyConComplementario: boolean;
    idSolicitud: string | undefined;
    isDesactivado: boolean;
    esVigente?: boolean;
}


const schema = Yup.object<Responsables>().shape({
    ejecutivoComercial: Yup.string().required("Campo requerido"),
    ejecutivoOperaciones: Yup.string().required("Campo requerido"),
    abogado: Yup.string().required("Campo requerido"),
});

const ResponsablesForm: React.FC<IProps> = (props) => {

    const { obtenerResponsables, responsables } = useResponsables(); // llamar una vez
    const { obtenerEjecutivos, ejecutivos } = useResponsables();
    const { obtenerAbogados, abogados } = useResponsables();
    const { obtenerConfeccionador, confeccionador } = useResponsables();
    const [isEditing, setIsEditing] = useState<boolean>(false);
    const { addToast } = useToast();
    const { hasPermission } = useUserRolesContext();
    const permisoCarteraMutuoEditarInfo = hasPermission(TipoFuncionalidad.Cartera_editar_info);
    const [modalConfirmacion, setModalConfirmacion] = useState({
        show: false,
        title: '',
        message: '',
        metodo: () => {
        },
    });

    const {
        formState: { errors, isDirty, isValid },
        handleSubmit,
        trigger,
        control,
        reset
    } = useForm<Responsables>({
        defaultValues: responsables,
        resolver: yupResolver(schema),
        mode: 'onChange',
    })

    useEffect(() => {
        obtenerResponsables(props.idMutuo);
    }, [props.idMutuo]);

    useEffect(() => {
        reset(responsables);
    }, [responsables, reset]);

    useEffect(() => {
        obtenerEjecutivos();
        obtenerAbogados();
        obtenerConfeccionador();
    }, []);

    const onSubmit = async (data: Responsables) => {

        const requestData: UpdateResponsables = {
            rutAbogado: data.abogado,
            rutEjecutivoComercial: data.ejecutivoComercial,
            rutEjecutivoOperaciones: data.ejecutivoOperaciones,
            mutuoId: props.idMutuo
        }

        const resp = await actualizarResponsables(requestData);
        if (resp.status === StatusCode.NoContent) {
            setIsEditing(false);
            addToast({
                mostrar: true,
                titulo: 'Confirmación',
                tipo: 'Success',
                mensaje: 'Datos modificados correctamente'
            });

            obtenerResponsables(props.idMutuo);
        }
    };

    const handleCancelar = () => {
        if (isDirty) {
            setModalConfirmacion({
                show: true,
                title: "Hay cambios sin guardar",
                message: '¿Desea abandonar el ingreso?',
                metodo: () => {
                    setIsEditing(false);
                    reset();
                },
            });
        }
        else {
            setIsEditing(false);
            reset();
        }
    }

    const handleCopy = () => {
        setModalConfirmacion({
            show: true,
            title: "Generar Copia",
            message: '¿Desea copiar la información de los representantes desde el mutuo normal?',
            metodo: () => {
                onCopy();
            },
        });
    }

    const onCopy = async () => {
        if (props.idSolicitud != null) {
            const resp = await copiarResponsables(props.idSolicitud);
            if (resp.status === StatusCode.NoContent) {
                setIsEditing(false);
                addToast({
                    mostrar: true,
                    titulo: 'Confirmación',
                    tipo: 'Success',
                    mensaje: 'Datos copiados correctamente'
                });

                obtenerResponsables(props.idMutuo);
            }
        }
    }

    const isReadonlyWithPermission = () => {
        let result = !isEditing || (props.esVigente && !permisoCarteraMutuoEditarInfo);
        return result ?? true;
    }

    return (
        <>
            <ConfirmationModal
                onHide={() =>
                    setModalConfirmacion({
                        ...modalConfirmacion,
                        show: false,
                    })
                }
                onConfirm={modalConfirmacion.metodo}
                show={modalConfirmacion.show}
                title={modalConfirmacion.title}
                message={modalConfirmacion.message}
            />
            <Card sx={{ mb: 2, mt: 2 }} raised>
                <CardContent>
                    <form>
                        <Grid2 container alignItems="center" spacing={2}>
                            <Grid2 size={2}>
                                <Typography className='card-title' variant="h6">Responsables</Typography>
                            </Grid2>

                            {!props.isComplementario && !isEditing ? (
                                <DetalleMutuoPermissionGuard
                                    esVigente={props.esVigente}
                                    permissions={[TipoFuncionalidad.Bandeja_editar, TipoFuncionalidad.Cartera_editar_info]}>
                                    <Grid2 container spacing={1} size={10} sx={{ textAlign: "right", justifyContent: 'flex-end' }}>
                                        <MButton
                                            variant="contained"
                                            startIcon={<EditIcon />}
                                            onClick={() => { setIsEditing(true); trigger(); }}
                                            disabled={props.isDesactivado}
                                        >
                                            {'Editar'}
                                        </MButton>
                                    </Grid2>
                                </DetalleMutuoPermissionGuard>
                            ) : (
                                !props.isComplementario ? (
                                    <Grid2 container spacing={0} size={10} sx={{ textAlign: "right", justifyContent: 'flex-end' }}>
                                        <MButton
                                            variant="contained"
                                            startIcon={<SaveAltIcon />}
                                            disabled={!(isDirty && isValid)}
                                            onClick={handleSubmit(onSubmit)}
                                        >
                                            Guardar
                                        </MButton>

                                        &nbsp;

                                        <MButton
                                            variant='contained'
                                            color='error'
                                            startIcon={<CloseIcon />}
                                            onClick={() => { handleCancelar() }}
                                        >
                                            Cancelar
                                        </MButton>
                                    </Grid2>
                                ) : (
                                    <DetalleMutuoPermissionGuard
                                        esVigente={props.esVigente}
                                        permissions={[TipoFuncionalidad.Bandeja_editar, TipoFuncionalidad.Cartera_editar_info]}>
                                        <Grid2 container spacing={1} size={10} sx={{ textAlign: "right", justifyContent: 'flex-end' }}>
                                            <MButton
                                                variant="contained"
                                                startIcon={<EditIcon />}
                                                onClick={() => { handleCopy() }}
                                            >
                                                {'COPIAR DESDE MUTUO NORMAL'}
                                            </MButton>
                                        </Grid2>
                                    </DetalleMutuoPermissionGuard>
                                )
                            )}

                        </Grid2>
                        <Grid2 container spacing={2}>
                            <Grid2 size={{ xs: 12, lg: 4 }}>
                                <InputSelectSearch
                                    label="Ejecutivo comercial"
                                    name="ejecutivoComercial"
                                    control={control}
                                    options={ejecutivos}
                                    disabled={isReadonlyWithPermission()}
                                    error={errors.ejecutivoComercial}
                                />
                            </Grid2>

                            <Grid2 size={{ xs: 12, lg: 4 }}>
                                <InputSelectSearch
                                    label="Abogado"
                                    name="abogado"
                                    control={control}
                                    options={abogados}
                                    disabled={isReadonlyWithPermission()}
                                    error={errors.abogado}
                                />
                            </Grid2>

                            <Grid2 size={{ xs: 12, lg: 4 }}>
                                <InputSelectSearch
                                    label="Ejecutivo operaciones"
                                    name="ejecutivoOperaciones"
                                    control={control}
                                    options={confeccionador}
                                    disabled={isReadonlyWithPermission()}
                                    error={errors.ejecutivoOperaciones}
                                />
                            </Grid2>
                        </Grid2>
                    </form>
                </CardContent>
            </Card>
        </>
    );
};

export default ResponsablesForm;

